import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    FuzzyTextMatchApi,
    FuzzyTextMatchRequest,
    FuzzyTextMatchResponseData,
} from '../fuzzy-text-match-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';

/**
 * 模糊文本匹配API实现
 * @description 实现在原文中模糊匹配指定文本的API操作
 */
@injectable()
export class FuzzyTextMatchApiImpl extends PsHttpService implements FuzzyTextMatchApi {

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }


    /**
     * 在原文中模糊匹配指定文本
     * @param data 模糊文本匹配请求参数
     * @returns 匹配结果
     * @description 调用后端API进行模糊文本匹配
     */
    async findTextInOrigin(data: FuzzyTextMatchRequest): Promise<FuzzyTextMatchResponseData> {
        const response = await this.post<PatSnapSuccessResponseData<FuzzyTextMatchResponseData>>({
            url: 'novelty-search/find-cell-from-ori-text',
            data,
            cache: true,
        });
        return response.data;
    }
}
